import { createAction } from 'redux-actions';

export const loadAllClients = createAction('LOAD_ALL_CLIENTS');
export const selectCurrentClient = createAction('SELECT_CURRENT_CLIENT');
export const paginateClients = createAction('PAGINATE_CLIENTS');
export const addFolderItems = createAction('ADD_FOLDER_ITEMS');
export const removeFolderItems = createAction('REMOVE_FOLDER_ITEMS');
export const addFolderItem = createAction('ADD_FOLDER_ITEM');
export const removeFolderItem = createAction('REMOVE_FOLDER_ITEM');
export const selectCustomFolder = createAction('SELECT_CUSTOM_FOLDER');
export const changeGeneralSearchTextClient = createAction('CHANGE_GENERAL_SEARCH_TEXT_CLIENT');
export const changeSortConfigClient = createAction('CHANGE_SORT_CONFIG_CLIENT');
export const setClearClientList = createAction('SET_CLEAR_CLIENT_LIST');
export const setNewCommunication = createAction('SET_NEW_COMMUNICATION');
export const setDeleteClientFromHome = createAction('SET_DELETE_CLIENT_FROM_HOME');
export const setSelectedCustomField = createAction('SET_SELECTED_CUSTOM_FIELD');
